import type { ApiResponse, ClubClosure, ClubOperatingHour } from '@court-sync/shared';
import type { ClubOperatingHourSlot } from '@court-sync/shared';
import { apiDelete, apiGet, apiPost, apiPut } from './apiClient';

export const clubHoursService = {
  async getOperatingHours(clubId: string): Promise<ApiResponse<ClubOperatingHour[]>> {
    return apiGet<ClubOperatingHour[]>(`/clubs/${clubId}/operating-hours`);
  },

  async updateOperatingHours(
    clubId: string,
    slots: ClubOperatingHourSlot[]
  ): Promise<ApiResponse<ClubOperatingHour[]>> {
    return apiPut<ClubOperatingHour[]>(`/clubs/${clubId}/operating-hours`, { slots });
  },

  async getClosures(clubId: string): Promise<ApiResponse<ClubClosure[]>> {
    return apiGet<ClubClosure[]>(`/clubs/${clubId}/closures`);
  },

  async addClosure(
    clubId: string,
    data: { startAt: string; endAt: string; reason?: string }
  ): Promise<ApiResponse<{ id: string }>> {
    return apiPost<{ id: string }>(`/clubs/${clubId}/closures`, data);
  },

  async removeClosure(clubId: string, closureId: string): Promise<ApiResponse<null>> {
    return apiDelete<null>(`/clubs/${clubId}/closures/${closureId}`);
  },
};
